import {Component, computed, inject, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {TenderDetailResponse} from '@frontend/shared-api';
import {rxResource} from '@angular/core/rxjs-interop';
import {RfiProjectDescriptionFormatterService} from '../../../../../shared/services/rfi-project-description-formatter.service';
import {LoadingComponent} from '../../../../../shared/components/loading/loading.component';
import {SubsectionTitleComponent} from '../../../../../shared/components/header/subsection-title/subsection-title.component';

@Component({
  selector: 'app-tender-project-description-rfi',
  imports: [TranslocoPipe, LoadingComponent, SubsectionTitleComponent],
  templateUrl: './tender-description-rfi.component.html',
})
export class TenderDescriptionRfiComponent {
  private readonly hrContentFormatter = inject(RfiProjectDescriptionFormatterService);

  readonly tenderDetails = input.required<TenderDetailResponse>();

  protected readonly formattedCharterContentResource = rxResource({
    params: () => {
      const {tenderId, industrialEmployees, salariedEmployees} = this.tenderDetails();
      return {tenderId, industrialEmployees, salariedEmployees};
    },
    stream: ({params: request}) =>
      this.hrContentFormatter.formatCompleteContentForProvider(request.tenderId, {
        industrialEmployees: request.industrialEmployees,
        salariedEmployees: request.salariedEmployees,
      }),
  });

  protected readonly formattedCharterContent = computed(
    () => this.formattedCharterContentResource.value() ?? '',
  );
}
